'use strict';

require('@/assets/css/base.css');

$('header').on('mouseenter', '.nav', function () {
    $('header .nav').removeClass('active');
    $(this).addClass('active');
}).on('mouseleave', function () {
    $('header .nav').removeClass('active');
});

$('.menus').on('click', function () {
    $('.m-menu').show();
    return false;
});

$('.m-menu').on('click', function (e) {
    return false;
});
$('.m-menu').on('click', 'a', function (e) {
    e.stopPropagation();
});

$(document).on('click', function () {
    $('.m-menu').hide();
});


//////////////////
// WEBPACK FOOTER
// ./src/router/global.js
// module id = a8H3zrkc
// module chunks = 4